<template>
  <BaseDatePicker
    :clearable="!field.isReadOnly && !disabled && !field.isRequired"    
    :disabled="disabled"
    :readonly="field.isReadOnly"
    :label="labelText"
    v-model="field.value"
    :maxlength="field.validations.maxLength"
    :counter="field.validations.maxLength"
    :hint="field.observations"
    :error-messages="fieldErrors"
    @input="validator.document.fields.$each[index].value.$touch()"
    @blur="validator.document.fields.$each[index].value.$touch()"
  />
</template>
<script>
export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
    },
    ctIndex: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    labelText() {
      return `${this.field.title}${this.field.isRequired ? " *" : ""}`;
    },
    fieldErrors() {
      const errors = [];
      if (this.validator.document) {
        if (!this.validator.document.fields.$each[this.index].value.$dirty)
          return errors;

        !this.validator.document.fields.$each[this.index].value.required &&
          errors.push(this.$t("RequiredField"));
      } else if (this.validator.contentTypeList) {
        if (
          !this.validator.contentTypeList.$each[this.ctIndex].document.fields
            .$each[this.index].value.$dirty
        )
          return errors;

        !this.validator.contentTypeList.$each[this.ctIndex].document.fields
          .$each[this.index].value.required &&
          errors.push(this.$t("RequiredField"));
      }

      return errors;
    },
  },
};
</script>